import { grey } from "@material-ui/core/colors";
import OHLogo from "../assets/img/OHLogo.png"
export const GA_IDENTIFIER = "mi_website"

export const PRIMARY = '#171733'
export const PRIMARY_TRANSPARENT = 'rgba(0, 0, 0, 0.0)'
export const SECONDARY = "#1174b6"
export const OH_LOGO = OHLogo